import getEmailAddressFromSipUri from '../../presenceManager/getEmailAddressFromSipUri';
import getRecipientDisplayName from '../selectors/getRecipientDisplayName';
import { ChatActivityState } from '../store/schema/ChatViewState';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import loc, { format } from 'owa-localize';
import { ucmaUnknownOrMultipleUserTypingName, ucmaUserTyping } from '../strings.locstring.json';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';

const styles = require('./ChatTypingIndicator.scss');
const classNames = require('classnames');

export interface ChatTypingIndicatorProps {
    userActivity: ChatActivityState;
    className?: string;
}

export default observer(function ChatTypingIndicator(props: ChatTypingIndicatorProps) {
    const { userActivity, className } = props;
    if (userActivity.type == 'StoppedTyping' || userActivity.type == 'None') {
        return null;
    } else {
        const isSolo = userActivity.type == 'Typing' && userActivity.linkedUserSip;
        const displayName = isSolo
            ? getRecipientDisplayName(userActivity.linkedUserSip)
            : loc(ucmaUnknownOrMultipleUserTypingName);

        return (
            <div className={classNames(styles.indicatorContainer, className)}>
                {isSolo && (
                    <PersonaControl
                        emailAddress={getEmailAddressFromSipUri(userActivity.linkedUserSip)}
                        name={displayName}
                        size={PersonaSize.size24}
                        showPersonaDetails={false}
                        coinProps={{
                            styles: {
                                imageArea: styles.personaCoinFix,
                            },
                        }}
                    />
                )}
                <span className={styles.isTypingText}>
                    {format(loc(ucmaUserTyping), displayName)}
                </span>
            </div>
        );
    }
});
